import { useContext } from 'react';

import { LocaleContext } from '@/hooks/LocaleContext';

export const useLocale = () => useContext(LocaleContext);
